export const FEED_COMMENTS_I18N_PREFIX = "features.home.components.feed_comments";

export const FEED_COMMENTS_I18N_KEYS = {
  constructive_label: "constructive_label",
  not_constructive_label: "not_constructive_label",
  constructive_hover_text: "constructive_hover_text"
}


// WEBPACK FOOTER //
// ./src/features/home/components/constants/i18n/FeedCommentsi18nConstants.js